import * as Sentry from '@sentry/react';
import { RefreshCw } from 'lucide-react';
import styles from './ErrorBoundary.module.css';

function Fallback({ resetError }) {
  return (
    <div className={styles.wrap} role="alert">
      <p className={styles.emoji} aria-hidden="true">😴</p>
      <h1 className={styles.title}>Something dozed off</h1>
      <p className={styles.text}>
        An unexpected error interrupted this page. We’ve been notified and are looking into it.
      </p>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primary}
          onClick={() => {
            resetError?.();
            window.location.reload();
          }}
        >
          <RefreshCw aria-hidden="true" /> Reload page
        </button>
        <a className={styles.secondary} href="/">
          Go to homepage
        </a>
      </div>
    </div>
  );
}

/** Top-level boundary: reports to Sentry and shows a recovery screen. */
export function AppErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={(props) => <Fallback {...props} />}>{children}</Sentry.ErrorBoundary>;
}

/** Page-level boundary so one broken page doesn't take the header/footer down. */
export function PageErrorBoundary({ children }) {
  return <Sentry.ErrorBoundary fallback={(props) => <Fallback {...props} />}>{children}</Sentry.ErrorBoundary>;
}
